import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/http/auth/auth.service';
import { UserService } from 'src/app/shared/services/http/user/user.service';
import { MatDialog } from '@angular/material/dialog';
import { RegistrationRequiredComponent } from 'src/app/home/popup/registration-required/registration-required.component';
import { DialogRegistrationsClosedComponent } from './dialog-registrations-closed/dialog-registrations-closed.component';
import { HostListener } from '@angular/core';
import { UtilService } from 'src/app/shared/services/util/util.service';
import { CartService } from 'src/app/shared/services/cart/cart.service';
import { ClientService } from 'src/app/shared/services/client.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  token:any=''
  userDetails:any
  userData: any
  public timedOutCloser:any;
  public targetMenuTrigger:any;
  isDropdownOpen = false;
  currentRoute: string = '';
  addToCartCount: number = 0;
  currentClient: any;
  currentClientConfigData: any;
  constructor(private dialog: MatDialog,private authService: AuthService,private router: Router, private service: UserService, private utilService:UtilService, private cartService: CartService, private clientService:ClientService) { }

  ngOnInit(): void {

    this.router.events.subscribe(() => {
      this.currentRoute = this.router.url;
      // console.log('Current route:', this.currentRoute); 
    });

    // Get current client details
    this.currentClientDetails();
    
    this.token=this.authService.getToken()
    if(this.token){
      this.userDetails=this.authService.getDataFromLocalStorage('user_details')
      this.userDetails=JSON.parse(this.userDetails)
    //  console.log(this.userDetails)
     if(this.userDetails?.registrationNo){     
      this.service.getProfiledata(this.userDetails?.registrationNo).subscribe((res:any)=>{
          this.userData=res.data;
          this.service.userData.next(res);
        })
      }
    }

    this.cartService.addToCartSubject.subscribe(count => this.addToCartCount = count);
  
    // Refresh count in case of page reload
    this.cartService.refreshCartCount();

  }

  currentClientDetails(){
    this.currentClient = this.clientService.getClientFromUrl();
    // console.log('Current Client:', this.currentClient);
    
    // Get client configuration from service (single source of truth)
    const config = this.clientService.getClientConfig(this.currentClient);
    // console.log(config);
    
    // Assign to local variable
    this.currentClientConfigData = config;
    // console.log(this.currentClientConfigData);
  }

  logout(){
    localStorage.clear();
    this.router.navigate([this.currentClient, 'auth', 'login']);
  }

  shouldShowButton(): boolean {   
    return !this.router.isActive('/exam-managment', true);
  }

  RegistrationRequired() {
    if( this.userData?.student?.paymentStatus ==='failed' || this.userData?.student?.paymentStatus ==='pending'){
      const dialogRef = this.dialog.open(RegistrationRequiredComponent, {
        width: '500px',
        data: {
          message: 'Hello World from Edupala',
        },
      }); 
      //dialogRef.close();
      // setTimeout(() => {
      //   dialogRef.close();
      // }, 5000);
    }else {
        this.router.navigate(['/exam-managment']);
    }
    
    // dialogRef.afterClosed().subscribe(result => {
    //   console.log('The dialog was closed');
    // });
   
  }

  openDialog(): void {
    this.dialog.open(DialogRegistrationsClosedComponent, {
      width: "490px",
    });
  }

  mouseEnter(trigger:any) {
    if (this.timedOutCloser) {
      clearTimeout(this.timedOutCloser);
    }
    trigger.openMenu();
  }

  mouseLeave(trigger:any) {
    this.timedOutCloser = setTimeout(() => {
      trigger.closeMenu();
    }, 50);
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const dropdownElement = (event.target as HTMLElement).closest('.position-relative');
    const cartButton = (event.target as HTMLElement).closest('.btn-cart');
    if (!dropdownElement || cartButton) {
      this.isDropdownOpen = false;
    }
  }

  addToCart() {
    this.router.navigate([this.currentClient, 'teacher', 'my-cart']);
  }

  onPurchaseHistory(){
    if(this.userDetails?.type != 'institute'){
      this.router.navigate([this.currentClient, 'teacher', 'purchase-history']);
    }else{
      this.router.navigate([this.currentClient, 'institute', 'payment-history']);
    }
    this.toggleDropdown();
  }
}
